import {
  ACTIVATE_TEMPLATE,
  APPEND_ITEMS,
  AUTHENTICATE,
  CHANGES_MADE,
  CLEAR_CHANGES,
  INVALID_VARIABLES,
  CHANGE_VARIABLE_ORDER,
  CHANGE_MODIFIER_ORDER,
  CHANGE_INSTANCE_ORDER,
  CLEAR_DELETED_VARIABLES,
  CLEAR_ITEM,
  CLEAR_NEW_VARIABLE,
  CLEAR_SCHEMA,
  CREATE_VARIABLE,
  CREATE_DATASOURCE,
  EDIT_DATASOURCE,
  CLEAR_EDIT_DATASOURCE,
  UPDATE_DATA_SOURCE,
  DELETE_DATA_SOURCE,
  UPDATE_DATA_SOURCE_NAME,
  GENERATE_GETTER,
  GENERATE_OPERATOR,
  CLONE_VARIABLE,
  DELETE_VARIABLE,
  DELETED_VARIABLES_CLEARED,
  DEACTIVATE_TEMPLATE,
  DEACTIVATE_TEMPLATES,
  EDIT_VARIABLE,
  EDIT_VARIABLES,
  EDIT_INSTANCE,
  HIDE_NAME_FIELD,
  HIDE_SELECTOR,
  INIT_NEW_VARIABLE,
  SET_MAX_TEMPLATES,
  SET_AUTH_STATUS,
  SET_PRIMARY_COLOR,
  SET_SECONDARY_COLOR,
  SET_PREVIEW_URL,
  SET_STAND_ALONE_MODE,
  SET_SHOW_CAVEON_ID_MODAL,
  SHOW_SELECTOR,
  STORE_TEMPLATES,
  STOP_EDITING,
  STOP_EDITING_VARIABLES,
  STORE_BEARER_TOKEN,
  STORE_ITEM,
  STORE_ITEMS,
  STORE_SCHEMA,
  STORE_USER,
  UPDATE_ITEM,
  UPDATE_OPTIONS_ORDER,
  UPDATE_MATCH_ORDER,
  UPDATE_ITEM_NAME,
  UPDATE_VARIABLE,
  UPDATE_VARIABLE_MACRO,
  UPDATE_VARIABLE_MODIFIER,
  UPDATE_VARIABLE_INSTANCE,
  UNAUTHENTICATE,
  UPDATE_ITEM_CODE,
  UPDATE_VAR_NAME_MAP
} from './types'

import 'whatwg-fetch'

export const activateTemplate = function (id) {
  return {
    type: ACTIVATE_TEMPLATE,
    id
  }
}
export const appendItems = function (items, hasNext) {
  return {
    type: APPEND_ITEMS,
    items,
    hasNext
  }
}
export const authenticate = function () {
  return {
    type: AUTHENTICATE
  }
}
export const changesMade = function () {
  return {
    type: CHANGES_MADE
  }
}
export const clearChanges = function () {
  return {
    type: CLEAR_CHANGES
  }
}
export const updateInvalidVariables = function (invalidVariables) {
  return {
    type: INVALID_VARIABLES,
    invalidVariables
  }
}
export const changeVariableOrder = function (name, oldIdx, newIdx) {
  return {
    type: CHANGE_VARIABLE_ORDER,
    oldIdx,
    newIdx,
    name
  }
}
export const changeModifierOrder = function (modifier, oldIdx, newIdx, variable) {
  return {
    type: CHANGE_MODIFIER_ORDER,
    modifier,
    oldIdx,
    newIdx,
    variable
  }
}
export const changeInstanceOrder = function (modifier, oldIdx, newIdx, variable, instanceId) {
  return {
    type: CHANGE_INSTANCE_ORDER,
    modifier,
    oldIdx,
    newIdx,
    variable,
    instanceId
  }
}
export const clearDeletedVariables = function () {
  return {
    type: CLEAR_DELETED_VARIABLES
  }
}
export const clearItem = function () {
  return {
    type: CLEAR_ITEM
  }
}
export const clearNewVariable = function () {
  return {
    type: CLEAR_NEW_VARIABLE
  }
}

export const clearSchema = function () {
  return {
    type: CLEAR_SCHEMA
  }
}
export const createVariable = function (varKey, varName, macroType) {
  return {
    type: CREATE_VARIABLE,
    varKey,
    varName,
    macroType,
    modifiers: [],
    instances: {}
  }
}
export const createDataSource = function ({ id, name, description, data, modifiedAt, columns }) {
  return {
    type: CREATE_DATASOURCE,
    id,
    name,
    description,
    data,
    modifiedAt,
    columns
  }
}
export const editDataSource = function (name) {
  return {
    type: EDIT_DATASOURCE,
    name
  }
}
export const clearDataSourceEdit = function () {
  return {
    type: CLEAR_EDIT_DATASOURCE
  }
}
export const updateDataSource = function (id, rows, columns) {
  return {
    type: UPDATE_DATA_SOURCE,
    id,
    rows,
    columns
  }
}
export const deleteDataSource = function (id) {
  return {
    type: DELETE_DATA_SOURCE,
    id
  }
}
export const updateDataSourceName = function (id, name) {
  return {
    type: UPDATE_DATA_SOURCE_NAME,
    id,
    name
  }
}
export const generateGetter = function (keyName, varName, args) {
  return {
    type: GENERATE_GETTER,
    keyName,
    varName,
    args
  }
}
export const generateOperator = function (keyName, varName, args) {
  return {
    type: GENERATE_OPERATOR,
    keyName,
    varName,
    args
  }
}
export const cloneVariable = function (keyName, varName, clonedObj) {
  return {
    type: CLONE_VARIABLE,
    keyName,
    varName,
    clonedObj
  }
}
export const deactivateTemplate = function (id) {
  return {
    type: DEACTIVATE_TEMPLATE,
    id
  }
}
export const deactivateTemplates = function () {
  return {
    type: DEACTIVATE_TEMPLATES
  }
}
export const deletedVariablesCleared = function () {
  return {
    type: DELETED_VARIABLES_CLEARED
  }
}
export const deleteVariable = function (varName) {
  return {
    type: DELETE_VARIABLE,
    varName
  }
}
export const editVariable = function (varName) {
  return {
    type: EDIT_VARIABLE,
    varName
  }
}
export const editingInstance = function (key = null) {
  return {
    type: EDIT_INSTANCE,
    key
  }
}
export const editVariables = function (varName) {
  return {
    type: EDIT_VARIABLES
  }
}
export const hideNameField = function () {
  return {
    type: HIDE_NAME_FIELD
  }
}
export const hideTemplateSelector = function () {
  return {
    type: HIDE_SELECTOR
  }
}
export const initNewVariable = function () {
  return {
    type: INIT_NEW_VARIABLE
  }
}
export const setPrimaryColor = function (color) {
  return {
    type: SET_PRIMARY_COLOR,
    color
  }
}
export const setAuthStatus = function (authStatus) {
  return {
    type: SET_AUTH_STATUS,
    authStatus
  }
}
export const setMaxTemplates = function (maximum) {
  return {
    type: SET_MAX_TEMPLATES,
    maximum
  }
}

export const setSecondaryColor = function (color) {
  return {
    type: SET_SECONDARY_COLOR,
    color
  }
}

export const setPreviewUrl = function (previewUrl) {
  return {
    type: SET_PREVIEW_URL,
    previewUrl
  }
}

export const setStandAloneMode = function (isInStandAloneMode) {
  return {
    type: SET_STAND_ALONE_MODE,
    isInStandAloneMode
  }
}

export const setShowCaveonIdModal = function (showCaveonIdModal) {
  return {
    type: SET_SHOW_CAVEON_ID_MODAL,
    showCaveonIdModal
  }
}

export const showTemplateSelector = function () {
  return {
    type: SHOW_SELECTOR
  }
}
export const stopEditingVariable = function () {
  return {
    type: STOP_EDITING
  }
}

export const stopEditingVariables = function () {
  return {
    type: STOP_EDITING_VARIABLES
  }
}
export const storeBearerToken = function (token) {
  return {
    type: STORE_BEARER_TOKEN,
    token
  }
}
export const storeItem = function (itemData) {
  return {
    type: STORE_ITEM,
    itemData
  }
}
export const updateVarNameMap = function (variables) {
  const varNameMap = {}
  for (const key in variables) { // eslint-disable-line no-unused-vars
    if (variables.hasOwnProperty(key)) { // eslint-disable-line no-prototype-builtins
      const variableObj = variables[key]
      varNameMap[key] = variableObj.name || key
    }
  }
  return {
    type: UPDATE_VAR_NAME_MAP,
    varNameMap: varNameMap
  }
}
export const storeItems = function (items, hasNext, doAppend) {
  return {
    type: STORE_ITEMS,
    items,
    hasNext
  }
}
export const storeSchema = function (schema) {
  return {
    type: STORE_SCHEMA,
    schema
  }
}
export const storeTemplates = function (templates) {
  return {
    type: STORE_TEMPLATES,
    templates
  }
}
export const storeUser = function (user) {
  return {
    type: STORE_USER,
    user
  }
}
export const unauthenticate = function () {
  return {
    type: UNAUTHENTICATE
  }
}

export const updateItem = function (key, value) {
  return {
    type: UPDATE_ITEM,
    key,
    value
  }
}
export const updatedOptionsOrder = function (newIdx, oldIdx, updatedOption) {
  return {
    type: UPDATE_OPTIONS_ORDER,
    newIdx,
    oldIdx,
    updatedOption
  }
}
export const updatedMatchesOrder = function (newIdx, oldIdx, updatedMatch) {
  return {
    type: UPDATE_MATCH_ORDER,
    newIdx,
    oldIdx,
    updatedMatch
  }
}
export const updateItemCode = function (code) {
  return {
    type: UPDATE_ITEM_CODE,
    code
  }
}
export const updateItemName = function (name) {
  return {
    type: UPDATE_ITEM_NAME,
    name
  }
}
export const updateVariable = function (keyName, varName, args) {
  return {
    type: UPDATE_VARIABLE,
    keyName,
    varName,
    args
  }
}
export const updateVariableMacro = function (varName, macro) {
  return {
    type: UPDATE_VARIABLE_MACRO,
    varName,
    macro
  }
}
export const updateVariableModifiers = function (varName, modifiers) {
  return {
    type: UPDATE_VARIABLE_MODIFIER,
    varName,
    modifiers
  }
}
export const updateVariableInstance = function (varName, instance, modifiers) {
  return {
    type: UPDATE_VARIABLE_INSTANCE,
    varName,
    instance,
    modifiers
  }
}
export const getAllTemplates = function () {
  return (dispatch, getState) => (
    fetch('/api/v1/templates', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getState().auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return {
        _error: res.statusText
      }
    }).then(data => {
      if (data._error) {
        console.assert(data._error)
        return false
      }
      dispatch(storeTemplates(data.results))
    })
  )
}

export const getTemplatesByTag = function (templateTags) {
  return (dispatch, getState) => (
    fetch(`/api/v1/templates?tags=${templateTags}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getState().auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return {
        _error: res.statusText
      }
    }).then(data => {
      if (data._error) {
        console.assert(data._error)
        return false
      }
      dispatch(storeTemplates(data.results))
    })
  )
}
export const getSchemas = function () {
  return (dispatch, getState) => {
    const state = getState()
    const selectedTemplates = state.templates.selected
    if (selectedTemplates.length > 0) {
      const stringIds = selectedTemplates.toString()
      fetch(`/api/v1/editor/schema?templateIds=${stringIds}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${state.auth.bearerToken}`
        }
      })
        .then(res => {
          if (res.status === 200) {
            return res.json()
          }
          return {
            _error: res.statusText
          }
        }).then(data => {
          if (data._error) {
            console.assert(data._error)
            return false
          }
          dispatch(storeSchema(data.schema))
        })
    } else {
      dispatch(clearSchema())
    }
  }
}

export const getItems = function (maxCreatedAt = null) {
  return (dispatch, getState) => {
    let url = '/api/v1/items'
    if (maxCreatedAt) {
      url += `?maxCreatedAt=${maxCreatedAt}`
    }
    return fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getState().auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return {
        _error: res.statusText
      }
    }).then(data => {
      if (data._error) {
        console.assert(data._error)
        return false
      }
      if (maxCreatedAt) {
        dispatch(appendItems(data.results, data.hasNext))
      } else {
        dispatch(storeItems(data.results, data.hasNext))
      }
      return true
    })
  }
}
export const getItem = function (itemId) {
  return (dispatch, getState) => (
    fetch(`/api/v1/items/${itemId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getState().auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return {
        _error: res.statusText
      }
    }).then(data => {
      if (data._error) {
        console.assert(data._error)
        return false
      }
      dispatch(storeItem(data))
      dispatch(updateVarNameMap(data.variables))
      dispatch(updateInvalidVariables([]))
      if (data.templateIds) {
        data.templateIds.forEach(id => {
          dispatch(activateTemplate(id))
        })
      }
      return true
    })
  )
}



// WEBPACK FOOTER //
// /app/js/actions/actions.js